import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(id) {
  return yield oncallFetch("/api/oncall/administration/partners/delete-logo", {
    id,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/partners/remove-logo.js